/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import keyMirror from 'external/keymirror';

export default keyMirror({
    REQUEST_STATIC_LAYERS: null,
    ADD_LAYER: null,
    SELECT_LAYER: null,
    DESELECT_LAYER: null,

    MAP_CONFIGS_ASYNC: null,

    ADD_LOGICAL_LAYER_ASYNC: null,
    UPDATE_LOGICAL_LAYER_ASYNC: null
});



// WEBPACK FOOTER //
// ./js/constants/ActionTypes.js